import nav1 from "../images/navan/1.jpg";
import nav2 from "../images/navan/2.jpg";
import nav3 from "../images/navan/3.jpg";
// import nav4 from "../images/navan/4.jpg";
import nav5 from "../images/navan/5.jpg";
import nav6 from "../images/navan/6.jpg";
import nav7 from "../images/navan/7.jpg";
import nav8 from "../images/navan/8.jpg";

import React, { Component } from "react";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators
  // CarouselCaption,
} from "reactstrap";

const items = [
  {
    src: nav1,
    altText: "Slide 1",
    caption: "Slide 1"
  },
  {
    src: nav2,
    altText: "Slide 2",
    caption: "Slide 2"
  },
  {
    src: nav3,
    altText: "Slide 3",
    caption: "Slide 3"
  },
  {
    src: nav1,
    altText: "Slide 1",
    caption: "Slide 1"
  },
  // {
  //   src: nav4,
  //   altText: "Slide 4",
  //   caption: "Slide 4"
  // },
  {
    src: nav5,
    altText: "Slide 5",
    caption: "Slide 5"
  },
  {
    src: nav6,
    altText: "Slide 6",
    caption: "Slide 6"
  },
  {
    src: nav7,
    altText: "Slide 7",
    caption: "Slide 7"
  },
  {
    src: nav8,
    altText: "Slide 8",
    caption: "Slide 8"
  }
];

class NavanCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = { activeIndex: 0 };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating) return;
    const nextIndex =
      this.state.activeIndex === items.length - 1
        ? 0
        : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  previous() {
    if (this.animating) return;
    const nextIndex =
      this.state.activeIndex === 0
        ? items.length - 1
        : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({ activeIndex: newIndex });
  }

  render() {
    const { activeIndex } = this.state;

    const slides = items.map(item => {
      return (
        // <div className="container d-flex row justify-content-center">
        <CarouselItem
          onExiting={this.onExiting}
          onExited={this.onExited}
          key={item.src}
        >
          <img
            src={item.src}
            alt={item.altText}
            className={"img-fluid"}
            // style={{ height: "380px" }}
          />
          {/* <CarouselCaption
            captionText={item.caption}
            captionHeader={item.caption}
            
          /> */}
        </CarouselItem>
        // </div>
      );
    });

    return (
      <Carousel
        activeIndex={activeIndex}
        next={this.next}
        previous={this.previous}
      >
        <CarouselIndicators
          items={items}
          activeIndex={activeIndex}
          onClickHandler={this.goToIndex}
        />
        {slides}
        <CarouselControl
          direction="prev"
          directionText="Previous"
          onClickHandler={this.previous}
        />
        <CarouselControl
          direction="next"
          directionText="Next"
          onClickHandler={this.next}
        />
      </Carousel>
    );
  }
}

export default NavanCarousel;
